import Payment from './Payment.page';

export default Payment;
